import { useMemo } from 'react';

import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { INITIAL_VALUE } from '../FilterForm/FilterForm.constants';

export const useInitialFilterValue = () => {
  const { defaultAcademicYear } = useAccessibleAccounts();

  return useMemo(
    () => ({ ...INITIAL_VALUE, academicYear: defaultAcademicYear || '' }),
    [defaultAcademicYear]
  );
};
